import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Quizz from "../views/Quizz.vue";
import Study from "../views/Study.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/jeu",
    name: "Quizz",
    component: Quizz,
  },
  {
    path: "/revisions",
    name: "Study",
    component: Study,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
